import NuCalController from  'nucal/controllers/NuCalController'; //the controller manages the arrival departure date
import NuCalAnnouncerView from 'nucal/views/NuCalAnnouncerView.js'; //the announcer announces for screen readers
import NuCalSingleCalendarWidget from 'nucal/views/composites/NuCalSingleCalendarWidget.js'; //this is the calendar widget which contains the individual


var bookingNode = document.querySelector('.cp-header__booking')
console.log(bookingNode)
if (bookingNode.classList.contains('cp-header__booking--nucal')) {
console.log('NuCal active')
const toggleRenderTemplate = function(date){
    this.view.innerHTML = `
    <div class="cp-booking-widget__column-content--month">${date.toLocaleDateString(this.locale,{ 'month': 'long' })}</div>
    <div class="cp-booking-widget__column-content--figure">${date.toLocaleDateString(this.locale,{ 'day': 'numeric'  })}</div>
    <div class="cp-booking-widget__column-content--controls cp-booking-widget__column-content--controls-down">
        <span class="icon-arrow-down"></span>
    </div>
    `;
}

const arrivalCalendar = new NuCalSingleCalendarWidget({
    'view': document.querySelector('.cp-booking-widget__arrival .cp-booking-widget__column-content'), //this is the div or element in which we create and render the calendar
    'namespace': 'mainCalendar', //use the same namespace to keep all related Modules in sync.
    'dateType': 'arrival', //this can be arrival or departure
    'inputId': 'arrival', //the <input id="?">
    'inputName': 'arrival', //the <input name="?">
    'toggleRenderTemplate': toggleRenderTemplate
});

const departureCalendar = new NuCalSingleCalendarWidget({
   'view': document.querySelector('.cp-booking-widget__departure .cp-booking-widget__column-content'), //this is the div or element in which we create and render the calendar
   'namespace': 'mainCalendar', //use the same namespace to keep all related Modules in sync.
   'dateType': 'departure', //this can be arrival or departure
   'inputId': 'departure', //the <input id="?">
   'inputName': 'departure', //the <input name="?">
   'toggleRenderTemplate': toggleRenderTemplate
});

const cal = new NuCalController({
    'namespace': 'mainCalendar'
});

window.nucal = {
    'mainCalendar': cal,
    'arrivalCalendar': arrivalCalendar,
    'departureCalendar': departureCalendar
};

}